export default "__VITE_ASSET__BYwx_0lM__"